/**
 * Twinkle product section — IE fallback, cart edit restore, cart:loaded
 * @module product-section
 * Config: [data-twinkle-product-section-config] JSON (from twinkle-product-section-scripts.liquid)
 */
(function () {
  function readConfig() {
    const el = document.querySelector('[data-twinkle-product-section-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  }

  function isIE() {
    const ua = window.navigator.userAgent;
    return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0;
  }

  function initIeFallback(config) {
    if (!isIE() || !config) return;

    const hiddenInput = document.querySelector(`#${config.productFormId} input[name="id"]`);
    const variantSwitcher =
      document.querySelector(`variant-radios[data-section="${config.sectionId}"]`) ||
      document.querySelector(`variant-selects[data-section="${config.sectionId}"]`);
    const noscriptWrapper = document.querySelector(`.product-form__noscript-wrapper-${config.sectionId}`);

    if (!hiddenInput || !variantSwitcher || !noscriptWrapper) return;

    const noScriptInputWrapper = document.createElement('div');
    noScriptInputWrapper.innerHTML = noscriptWrapper.textContent;
    variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;

    const variantsSelect = document.querySelector(`#Variants-${config.sectionId}`);
    variantsSelect?.addEventListener('change', (event) => {
      hiddenInput.value = event.currentTarget.value;
    });
  }

  function restoreLineItemProperties(properties) {
    for (const [key, value] of Object.entries(properties)) {
      if (typeof value !== 'object') {
        if (key.startsWith('_pdp_addon_')) {
          const [variantId, qtyRaw] = String(value).split(':');
          const qtyNum = parseInt(qtyRaw, 10) || 0;
          document.querySelectorAll(`input[name='properties[${key}]']`).forEach((input) => {
            if (input.classList.contains('input-number')) {
              input.value = qtyNum;
              input.dataset.oldValue = String(qtyNum);
              input.dispatchEvent(new Event('input', { bubbles: true }));
            } else {
              input.value = `${variantId}:${qtyNum}`;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          continue;
        }

        document.querySelectorAll(`input[name='properties[${key}]']`).forEach((input) => {
          if (input?.type === 'hidden') {
            input.type = 'text';
            input.value = value;
            input.type = 'hidden';
          }
          if (input?.type === 'text') {
            if (input.name.startsWith('properties[_')) {
              input.value = value.split(':')[1];
            } else {
              input.value = value;
            }
          }
          input.dispatchEvent(new Event('change'));
        });
      } else if (key === 'Accessories') {
        for (const [accessoryHandle, accessoryQty] of Object.entries(value)) {
          const qtyNum = parseInt(accessoryQty, 10) || 0;
          const accessoriesInput = document.querySelector(
            `input[name='properties[Accessories][${accessoryHandle}]']`
          );
          if (accessoriesInput) {
            accessoriesInput.value = qtyNum;
            accessoriesInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          const inputNumber = document.querySelector(`.input-number[data-handle="${accessoryHandle}"]`);
          if (!inputNumber) continue;

          const variantId = inputNumber.dataset.variant;
          inputNumber.value = qtyNum;
          inputNumber.dataset.oldValue = String(qtyNum);
          document.querySelectorAll(`input[name="${inputNumber.name}"]`).forEach((input) => {
            if (input.classList.contains('input-number')) {
              input.value = qtyNum;
              input.dataset.oldValue = String(qtyNum);
            } else {
              input.value = `${variantId}:${qtyNum}`;
            }
          });
          inputNumber.dispatchEvent(new Event('input', { bubbles: true }));
        }
      } else {
        for (const [key2, val] of Object.entries(value)) {
          const input = document.querySelector(`input[name='properties[${key}][${key2}]']`);
          if (input?.type === 'hidden') {
            input.type = 'text';
            input.value = val;
            input.dispatchEvent(new Event('change'));
            input.type = 'hidden';
          }
        }
      }
    }
  }

  function restoreCustomizationToggles(properties) {
    const productOptionsWrapper = document.querySelector('.product-options-wrapper');
    const subNode = productOptionsWrapper?.querySelector('.product-option-selector.checked');
    const ingredientsToggle = document.querySelector('#toggleIngredients');
    const addonToggle = document.querySelector('.addon-product-toggle');
    const customizationProduct = document.querySelector('customization-product');

    if (ingredientsToggle && productOptionsWrapper) {
      const selectedValue = (subNode?.dataset?.value || '').trim().toLowerCase();
      const isEmptyCakeOption = selectedValue === 'none' || selectedValue === 'nothing' || selectedValue === 'لا أحد';
      ingredientsToggle.checked = Boolean(subNode) && !isEmptyCakeOption;
      ingredientsToggle.dispatchEvent(new Event('change', { bubbles: true }));
      customizationProduct?.updateInputs?.(ingredientsToggle);
    }

    if (addonToggle && properties.Accessories) {
      const accessoryValues = Object.values(properties.Accessories);
      addonToggle.checked = accessoryValues.some((qty) => parseInt(qty, 10) > 0);
      addonToggle.dispatchEvent(new Event('change', { bubbles: true }));
      customizationProduct?.updateInputs?.(addonToggle);
    }

    if (typeof TwinkleProductForm !== 'undefined') {
      TwinkleProductForm.syncPdpAddonInputsFromUI(customizationProduct);
    }

    customizationProduct?.recalculateAdditionalPrice?.();
    customizationProduct?.updateTotalPrice?.();
    customizationProduct?.syncAllQtyButtonStates?.();
  }

  async function initEditRestore(config) {
    if (!config?.productHandle) return;

    const root = window.Shopify?.routes?.root || '/';
    const data = await fetch(`${root}cart.js`).then((response) => response.json());
    const cartItem = data?.items?.find((item) => item.handle === config.productHandle);

    if (!cartItem) {
      localStorage.removeItem('edit-product-key');
      window.TwinkleCart?.syncEditStateFromCart?.(data);
      return;
    }

    document.querySelector('variant-radios')?.onVariantChange();
    localStorage.setItem('edit-product-key', cartItem.key);
    localStorage.setItem('edit-product-handle', config.productHandle);

    const properties = cartItem.properties;
    if (properties && Object.entries(properties).length > 1) {
      restoreLineItemProperties(properties);
      restoreCustomizationToggles(properties);
      localStorage.setItem('edit-product', String(cartItem.id));
      document.querySelector('variant-radios')?.onVariantChange();
    }
  }

  async function initCartLoaded() {
    const root = window.Shopify?.routes?.root || '/';
    const cart = await fetch(`${root}cart.js`).then((response) => response.json());
    document.dispatchEvent(new CustomEvent('cart:loaded', { detail: { cart } }));
  }

  function init() {
    const config = readConfig();
    if (!config) return;

    initIeFallback(config);

    if (config.restoreFromCart) {
      initEditRestore(config).catch((error) => console.error('product-section: edit restore failed', error));
    }

    if (config.dispatchCartLoaded) {
      initCartLoaded().catch((error) => console.error('product-section: cart loaded failed', error));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
